import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import navLogo from '../assets/images/layout/nochedemuertos_pos_sm.png';
import { useActiveSection } from '../contexts/ActiveSectionContext';

export default function Navigation() {
  const { currentUser } = useAuth();
  const [displayName, setDisplayName] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminLoading, setAdminLoading] = useState(true);
  const { activeSection, setActiveSection } = useActiveSection();
  const location = useLocation();

  // Track route changes to update active section
  useEffect(() => {
    const pathToSection = {
      '/': 'home',
      '/el-libro': 'section1',
      '/personajes': 'personajes_select',
      '/section3': 'section3',
      '/capitulos': 'section4',
      '/profile': 'profile',
      '/login': 'login',
      '/add-character': 'add-character',
      '/eventos': 'eventos'
    };
    
    setActiveSection(pathToSection[location.pathname] || 'home');
  }, [location, setActiveSection]);

  // Check admin status (original code)
  useEffect(() => {
    if (!currentUser) {
      setIsAdmin(false);
      setAdminLoading(false);
      return;
    }

    const unsubscribe = onSnapshot(doc(db, 'admins', currentUser.uid), (doc) => {
      setIsAdmin(doc.exists());
      setAdminLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  // Fetch display name (original code)
  useEffect(() => {
    const fetchDisplayName = async () => {
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists()) {
            setDisplayName(userDoc.data().displayName);
          }
        } catch (error) {
          console.error("Error fetching display name:", error);
        }
      }
    };

    fetchDisplayName();
  }, [currentUser]);

  const isActive = (section) => activeSection === section;

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <Navbar.Brand as={Link} to="/" onClick={() => setActiveSection('home')}>
          <img
            src={navLogo}
            alt="Noche de Muertos Día de la Vida"
            className="nav-logo"
            style={{ height: '50px' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          <Nav className="me-auto">
            {/* Home Link */}
            <Nav.Link
              as={Link}
              to="/"
              className={isActive('home') ? 'active-nav' : ''}
              onClick={() => setActiveSection('home')}
            >
              Inicio
            </Nav.Link>

            {/* Public Sections */}
            

            <Nav.Link
              as={Link}
              to="/personajes"
              className={isActive('personajes_select') ? 'active-nav' : ''}
              onClick={() => setActiveSection('personajes_select')}
            >
              Personajes
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/capitulos"
              className={isActive('section4') ? 'active-nav' : ''}
              onClick={() => setActiveSection('section4')}
            >
              Capítulos
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/el-libro"
              className={isActive('section1') ? 'active-nav' : ''}
              onClick={() => setActiveSection('section1')}
            >
              Sobre el libro
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/eventos"
              className={isActive('eventos') ? 'active-nav' : ''}
              onClick={() => setActiveSection('eventos')}
            >
              Eventos
            </Nav.Link>

            {/* Authenticated Sections */}
            {currentUser && (
              <>

                <Nav.Link
                  as={Link}
                  to="/tu-perfil"
                  className={isActive('profile') ? 'active-nav' : ''}
                  onClick={() => setActiveSection('profile')}
                >
                  Tu perfil
                </Nav.Link>

                {/* Admin Section */}
                {!adminLoading && isAdmin && (
                  <Nav.Link
                    as={Link}
                    to="/add-character"
                    className={isActive('add-character') ? 'active-nav' : ''}
                    onClick={() => setActiveSection('add-character')}
                  >
                    Add Character
                  </Nav.Link>
                )}
              </>
            )}
          </Nav>

          {/* Auth Section */}
          <Nav>
            {currentUser ? (
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted d-none d-md-block">
                  {displayName || currentUser.email.split('@')[0]}
                </span>
                <Button
                  variant="outline-danger"
                  onClick={() => signOut(auth)}
                  size="sm"
                >
                  Salir
                </Button>
              </div>
            ) : (
              <Nav.Link
                as={Link}
                to="/login"
                className={isActive('login') ? 'active-nav' : ''}
                onClick={() => setActiveSection('login')}
              >
                Ingresar
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}